import z from 'zod';
import {
  coerceLiteralNumberRequired,
  FIRST_VERSION_TIMESTAMP,
  ZodVersionedMetadata
} from '~/lib/zod';
import { TenantCustomer } from '~/tenants/common/TenantPersona';

export const MlmCustomerSchema = {
  [FIRST_VERSION_TIMESTAMP]: z.object({
    version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
  }),
};

export type MlmCustomerMetadata = ZodVersionedMetadata<typeof MlmCustomerSchema>;

export default class MlmCustomer extends TenantCustomer<MlmCustomerMetadata> {

}
